import React from "react";
import ProductCard from '../../CommonComponents/ProductCard';

export default function ProductGrid({ products, onEdit, onDelete, onPreviewImage, uploadsBaseURL, showActions = true }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {products.map((p) => (
                <ProductCard
                    key={p.id}
                    product={{
                        id: p.id,
                        name: p.name || p.product_name || '',
                        image: p.image_url ? `${uploadsBaseURL}/${p.image_url}` : p.image ? p.image : undefined,
                        stock: typeof p.stock === 'number' ? p.stock : (typeof p.quantity === 'number' ? p.quantity : 0),
                        description: p.description || p.product_description || '',
                        price: typeof p.price === 'number' && p.price > 0 ? p.price : '',
                    }}
                    onEdit={showActions ? () => onEdit(p) : undefined}
                    onDelete={showActions ? () => onDelete(p) : undefined}
                    showActionsOnly={showActions}
                    showQuantityControl={showActions}
                    showOutOfStockLabel={false}
                    showBranchWarehouseLabels={false}
                    showUnitType={true}
                    unitType={p.unit_type}
                    onPreviewImage={() => onPreviewImage?.(p)}
                />
            ))}
        </div>
    );
}
